import { Component, HostListener } from '@angular/core';
import { sideBarTutor1, sideBarTutor2 } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'mindbase-tutor-sidebar',
  templateUrl: './tutor-sidebar.component.html',
  styleUrl: './tutor-sidebar.component.scss'
})
export class TutorSidebarComponent {
  assetsConst = assets;
  public sideBar = sideBarTutor1;
  public sideBar2 = sideBarTutor2;

  public innerWidth = 0;
  public sidenavWidth = 5;

  constructor(public _authService: AuthService) {}
  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

}
